// Black
export const PRIMARY_BLACK = "rgba(17, 24, 39, 1)";

// Grey colors
export const PRIMARY_GREY = "rgba(243, 245, 248, 1)"; // Light grey
export const SECONDARY_GREY = "rgba(228, 231, 236, 1)";
export const MID_GREY = "rgba(174, 179, 187, 1)";
export const TERTIARY_GREY = "rgba(74, 84, 102, 1)";
export const QUATERNARY_GREY = "rgba(49, 57, 74, 1)"; // Dark grey

// Brand
export const PRIMARY_BLUE = "rgba(50, 101, 234, 1)";
export const BLUE_LIGHT = "rgba(229, 235, 253, 1)";
export const OLD_BLUE = "rgba(20, 83, 245, 1)"; // We need to check with UI/UX if they want to switch all blue over.
export const BACKGROUND_LIGHT = "rgba(255, 255, 255, 1)";
export const LIGHT_BACKGROUND = "rgba(250, 250, 251, 1)";

// Error flow colors
export const ERROR_COLOR = "rgba(135, 37, 37, 1)";
export const ERROR_DARK = "rgba(63, 7, 7, 1)";
export const ERROR_LIGHT = "rgba(135, 37, 37, 0.16)";
export const SUCCESS_DARK_BACKGROUND = PRIMARY_BLACK;
export const DELETE = "rgba(185, 60, 60, 1)";
export const DELETE_PRESSED = "rgba(158, 53, 53, 1)";
export const YELLOW_ALERT = "rgba(242, 199, 72, 1)";

// Buttons colors
export const BUTTON_PRIMARY = PRIMARY_BLUE;
export const BUTTON_PRIMARY_BORDER = "rgba(0, 92, 214, 1)";
export const BUTTON_BOX_SHADOW = "rgba(255, 255, 255, 0.2)";
export const GHOST_BACKGROUND = BLUE_LIGHT;
export const GHOST_BACKGROUND_PRESSED = "rgba(221, 227, 245, 1)";
export const DISABLED_BACKGROUND = "rgba(20, 83, 245, 0.18)";
export const DISABLED_COLOR = "rgba(160, 164, 173, 1)";
export const DISABLED_SECONDARY = "rgba(98, 111, 134, 1)";

// Fonts colors
export const HEADING = PRIMARY_BLACK;
export const LIGHT_FONT = "rgba(255, 255, 255, 1)";
export const PRIMARY_FONT = QUATERNARY_GREY;
export const SECONDARY_FONT = TERTIARY_GREY;

// Status Badges
export const DRAFT_BG = "rgba(237, 241, 248, 1)";
export const DRAFT_TEXT = "rgba(74, 84, 102, 1)";
export const INVITED_BG = "rgba(237, 237, 240, 1)";
export const INVITED_TEXT = PRIMARY_BLACK;
export const REOPENED_FOR_EDIT_BG = "rgba(245, 240, 235, 1)";
export const REOPENED_FOR_EDIT_TEXT = "rgba(102, 51, 0, 1)";
export const READY_TO_SUBMIT_BG = "rgba(244, 241, 238, 1)";
export const READY_TO_SUBMIT_TEXT = "rgba(140, 103, 39, 1)";
export const SUBMITTED_BG = "rgba(237, 241, 252, 1)";
export const SUBMITTED_TEXT = "rgba(23, 88, 255, 1)";
export const SUBMISSION_FAILED_BG = ERROR_LIGHT;
export const SUBMISSION_FAILED_TEXT = ERROR_COLOR;
export const PRE_APPROVED_BG = "rgba(246, 239, 245, 1)";
export const PRE_APPROVED_TEXT = "rgba(188, 60, 124, 1)";
export const CLEAR_TO_CLOSE_BG = "rgba(241, 237, 251, 1)";
export const CLEAR_TO_CLOSE_TEXT = "rgba(111, 65, 230, 1)";
export const CLOSED_BG = "rgba(238, 242, 246, 1)";
export const CLOSED_TEXT = "rgba(34, 99, 146, 1)";
export const FUNDED_BG = "rgba(236, 243, 241, 1)";
export const FUNDED_TEXT = "rgba(1, 124, 63, 1)";
export const DECLINED_BG = "rgba(246, 239, 241, 1)";
export const DECLINED_TEXT = "rgba(185, 60, 60, 1)";
export const AWAITING_SIGNATURE_BG = "#fef3c7";
export const AWAITING_SIGNATURE_TEXT = "#b45309";

// Application origin badges
export const ORIGIN_DGA_BG = "rgba(229, 235, 253, 1)";
export const ORIGIN_DGA_TEXT = "rgba(23, 88, 255, 1)";
export const ORIGIN_DLA_BG = "rgba(236, 249, 245, 1)";
export const ORIGIN_DLA_TEXT = "rgba(4, 120, 87, 1)";
export const ORIGIN_DIGIFI_BG = "rgba(245, 240, 250, 1)";
export const ORIGIN_DIGIFI_TEXT = "rgba(107, 70, 193, 1)";
